/* =============================================================================
   lp-sticky.js — shared bottom sticky offer bar (LP framework §3.9).
   Portal to body, scroll reveal, root state class. Selection-aware UI stays in
   section JS (e.g. lp-col-bogo-st-11.js) via data-lp-sticky-* hooks.

   Public API (extends window.BBELP):
     BBELP.sticky.resolve(root, rootId)  -> sticky element (portaled)
     BBELP.sticky.reveal(sticky, root)
     BBELP.sticky.hide(sticky, root)
     BBELP.sticky.scrollY()
     BBELP.sticky.scrollThreshold(mobilePx, desktopPx)
     BBELP.sticky.scrollTo(el)
     BBELP.sticky.suppress(on)  -> hide all stickies while modal open
============================================================================= */
(function () {
  "use strict";

  window.BBELP = window.BBELP || {};

  var STICKY_HIDE_MS = 280;
  var stickyHideTimer = null;
  var DEFAULT_MOBILE_THRESHOLD = 80;
  var DEFAULT_DESKTOP_THRESHOLD = 200;

  function scrollY() {
    var doc = document.documentElement;
    var body = document.body;
    return Math.max(
      window.scrollY || 0,
      window.pageYOffset || 0,
      (doc && doc.scrollTop) || 0,
      (body && body.scrollTop) || 0
    );
  }

  function scrollThreshold(mobilePx, desktopPx) {
    var mobile = mobilePx == null ? DEFAULT_MOBILE_THRESHOLD : mobilePx;
    var desktop = desktopPx == null ? DEFAULT_DESKTOP_THRESHOLD : desktopPx;
    return window.matchMedia("(max-width: 767px)").matches ? mobile : desktop;
  }

  function scrollTo(el) {
    if (!el) return;
    var instant = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    el.scrollIntoView({ behavior: instant ? "auto" : "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    if (!sticky) return;
    if (stickyHideTimer) {
      clearTimeout(stickyHideTimer);
      stickyHideTimer = null;
    }
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    void sticky.offsetWidth;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    if (stickyHideTimer) clearTimeout(stickyHideTimer);
    var hideDelay = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : STICKY_HIDE_MS;
    stickyHideTimer = setTimeout(function () {
      stickyHideTimer = null;
      if (!sticky || sticky.classList.contains("is-visible")) return;
      sticky.hidden = true;
      sticky.setAttribute("hidden", "");
    }, hideDelay);
  }

  function resolveSticky(root, rootId) {
    if (!root && !rootId) return null;
    var sticky = root ? root.querySelector("[data-lp-sticky]") : null;
    if (!sticky && rootId) {
      sticky = document.querySelector(
        'body > [data-lp-sticky][data-lp-sticky-root-id="' + rootId + '"]'
      );
    }
    document.querySelectorAll("body > [data-lp-sticky]").forEach(function (el) {
      if (sticky && el !== sticky) el.remove();
    });
    if (sticky && sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }
    if (sticky && rootId) {
      sticky.setAttribute("data-lp-sticky-root-id", rootId);
      sticky.dataset.lpStickyPortaled = "1";
    }
    return sticky;
  }

  function suppress(on) {
    document.body.classList.toggle("lp-sticky-suppressed", on !== false);
  }

  window.BBELP.sticky = {
    resolve: resolveSticky,
    reveal: revealSticky,
    hide: hideSticky,
    scrollY: scrollY,
    scrollThreshold: scrollThreshold,
    scrollTo: scrollTo,
    suppress: suppress,
  };
})();
